import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { makeStyles } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'

const useStyles = makeStyles(() => ({
  container: {
    border: '1px solid',
    borderRadius: '8px',
    backgroundColor: COLORES.black,
    padding: '5px',
    '@media (min-width: 1020px)': {
      padding: '12px'
    }
  },
  nombreBuque: {
    margin: 0,
    fontSize: '1rem',
    '@media (min-width: 1020px)': {
      fontSize: 'inherit'
    }
  }
}))

function TotalPorBuque (props) {
  const { totalPorBuque } = props
  const classes = useStyles()

  const renderDataBuque = () => {
    const datos = totalPorBuque && totalPorBuque.length > 0 && totalPorBuque.map((b) => {
      return (
        <div
          key={b}
          style={{
            margin: '2% auto 8% auto',
            backgroundColor: COLORES.grey.light,
            borderRadius: '18px 8px 18px 8px',
            padding: '12px'
          }}
        >
          <Row style={{ margin: 'auto' }}>
            <Col
              md={12}
              className={classes.container}
              style={{ backgroundColor: COLORES.blue.primaryDark, color: 'white' }}
            >
              <h5 className={classes.nombreBuque}> Buque: <b style={{ fontSize: '1.5rem' }}> {b.nombreBuque}</b></h5>
            </Col>
          </Row>
          <Row style={{ margin: '2% auto' }}>
            <Col md={12} className={classes.container}>
              <h6 style={{ margin: 0 }}>
                A cargar: <b style={{ fontSize: '1.3rem' }}>{b.aCargar.toLocaleString('es-ES')} kg.</b>
              </h6>
            </Col>
          </Row>
          <Row style={{ margin: '0 auto' }}>
            <Col md={6} className={classes.container}>
              <h6>Cargado</h6>
              <h5><b>{b.cargado.toLocaleString('es-ES')} kg.</b></h5>
            </Col>
            <Col md={6} className={classes.container}>
              <h6>Restante</h6>
              <h5><b>{b.restante.toLocaleString('es-ES')} kg.</b></h5>
            </Col>
          </Row>
        </div>
      )
    })
    return datos
  }

  return (
    <div style={{ margin: 'auto' }}>
      { renderDataBuque() }
    </div>
  )
}

export default TotalPorBuque
